import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import RingcentralRegularAi from './ringcentral-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <RingcentralRegularAi {...validProps} />;
}
SvgComponent.iconName = 'ringcentralRegularAi';

export const RingcentralRegularAiIcon = svgIconWrapper(SvgComponent);
